import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import BuilderCard from './builder-card';
import NextDestinationPanel from './next-destination-panel';
import CalendarPanel from './calendar-panel';
import { FetchCapacity } from '../../../../actions/capacity';
import { SetCityID } from '../../../../actions/currentBooking';
import _filter from 'lodash/filter';
import ReactModal from 'react-modal';

class DestinationPanel extends PureComponent {

  constructor(props){
    super(props);
    this.state = {
      nextDestinationVisible:true,
      destinationVisible:false,
      calendarVisible:false,
      mapIsOpen:false
    }
    this.onDestinationClose = this.onDestinationClose.bind(this);
    this.onAddDestination = this.onAddDestination.bind(this);
    this.onCalendarClose = this.onCalendarClose.bind(this);
    this.openMapModal = this.openMapModal.bind(this);
    this.closeMapModal = this.closeMapModal.bind(this);
  }

  openMapModal(){ this.setState({mapIsOpen:true}); }
  closeMapModal(){ this.setState({mapIsOpen:false}); }

  toggleViews(view){
    switch (view) {
      case 'nextDestination':
          this.setState({nextDestinationVisible:true, destinationVisible:false, calendarVisible:false});
        break;
      case 'destination':
          this.setState({nextDestinationVisible:false, destinationVisible:true, calendarVisible:false}, () => {
            document.querySelector('.destination-panel').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
          });
        break;
      case 'calendar':
          this.setState({nextDestinationVisible:false, destinationVisible:false, calendarVisible:true});
        break;
      default:
        this.setState({nextDestinationVisible:true, destinationVisible:false, calendarVisible:false});
    }
  }


  componentDidUpdate(prevProp, prevState){

    const {
      destinations,
      promptIsOpen
    } = this.props;


    if(destinations !== prevProp.destinations){
      this.toggleViews('destination');
    }


    //close next destination panel if last remove trip is clicked
    if(promptIsOpen !== prevProp.promptIsOpen){
      if(this.state.destinationVisible){
        this.toggleViews('nextDestination');
      }
    }

  }

  onDestinationClose(){
    this.toggleViews('nextDestination');
  }

  onCalendarClose(type){
    if(type === 'destination') this.toggleViews('destination');
    if(type === 'next-destination') this.toggleViews('nextDestination');
  }

  onAddDestination(cityID, name, departureID, tripType){

    const {
      FetchCapacity,
      SetCityID,
      itineraries: { iso_currency, tms_group_booking_id, trips}
    } = this.props;

    this.toggleViews('calendar');

    if(tripType === 'sector'){

      // Fetch selected destination (sector)
      FetchCapacity(trips[0].tour_id, iso_currency, departureID, {}, "", tms_group_booking_id);

      // Save city id (sector)
      SetCityID(cityID);

    }
    else if(tripType === 'product'){

      // Fetch tour capacity
     FetchCapacity(departureID, iso_currency, "", {}, "", tms_group_booking_id);

    }

  }

  renderFixedProductMessage(){
    return(
      <div className="fixed-product-text">
        <span className="roundal">Or</span>
        <p>Link up with these popular tours</p>
      </div>
    )
  }



  renderDestinationPanel(){

    const { destinations } = this.props;

    return (
      <div className="destination-panel">
        <div className="row">
          <div className="column small-10">
            <div className="row">
            <div className="column small-12 medium-6 large-5">
              <p className={`no-margin uppercase select-text ${destinations.length > 0 ? '' : 'no-destinations'}`}>
                { destinations.length > 0 ? `Select next destination` : `Oops, no destination lefts` }
              </p>
            </div>

            <div className="column small-12 medium-6 large-7">
              <button className="busabout--cta--outline orange see-network-map" onClick={this.openMapModal}>
                <span className="ba-icon ba_icon_map"></span> See network map
              </button>
            </div>
            </div>

          </div>
          <div className="column small-2 text-right">
            <svg onClick={this.onDestinationClose} className="destination-close" width="19" height="19" viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.978 9.56l7.673-7.713a.678.678 0 0 0 0-.956l-.475-.478a.67.67 0 0 0-.951 0L9.552 8.127 1.88.418a.67.67 0 0 0-.95 0L.453.896a.678.678 0 0 0 0 .956L8.126 9.56.46 17.274a.678.678 0 0 0 0 .956l.475.478a.67.67 0 0 0 .95 0l7.667-7.714 7.673 7.714a.67.67 0 0 0 .95 0l.476-.478a.678.678 0 0 0 0-.956L10.978 9.56z" fill="#000000" fillRule="nonzero" opacity=".501"/>
            </svg>
          </div>
        </div>

        <div className="row margin-t-30">
          <div className="column small-12 destinations">
              {
                this.props.destinations.map((item, index) => {

                  return (
                    <Fragment key={index}>

                      { item.type === 'product' ? this.renderFixedProductMessage() : ''}

                       <BuilderCard
                          id={'next-destination-view'}
                          showClose={false}
                          showPlus={true}
                          data={item}
                          type={item.type}
                          image={_filter( (item.type === 'sector' || item.type === undefined) ? this.props.cities : this.props.cyoaProducts, ['name', item.name])[0] }
                          onPlusClicked={() => this.onAddDestination(item.tms_stage_id, item.name, item.departure_id, item.type)}
                        />

                    </Fragment>
                  )
                })
              }
          </div>
        </div>
      </div>
    )
  }


  render(){

    const { nextDestinationVisible, destinationVisible, calendarVisible, mapIsOpen } = this.state;

    return (
      <Fragment>
        { nextDestinationVisible &&  <NextDestinationPanel /> }
        { destinationVisible && this.renderDestinationPanel() }
        { calendarVisible && <CalendarPanel onCalendarClose={this.onCalendarClose} id={'next-destination-panel'} /> }

        <ReactModal
          className="map-modal"
          overlayClassName="modal-overlay semi-white scroll"
          isOpen={mapIsOpen}
          onRequestClose={this.closeMapModal}
          contentLabel="Share modal">
           <div className="map-modal-container">
              <div className="row">
                <div className="column small-12">
                  <img alt="Coach Network 2019 Map"
                data-src="https://images.ctfassets.net/3ng3kfj0qs70/5s70tYJpSMYKOQgEMYYQ8A/dc3dac3e42b4e14ecbfe508e96b46608/hoho-map.gif"
                className="lazyload" />
                </div>
              </div>

              <button className="close-button orange" onClick={this.closeMapModal}></button>
           </div>
        </ReactModal>

      </Fragment>
    )
  }
}


function mapStateToProps(state){
  return {
    cities:state.cities.data,
    destinations:state.destinations.data,
    capacity:state.capacity.data,
    currentBooking:state.currentBooking,
    cyoaProducts:state.cyoaProducts.data,
    itineraries:state.itineraries.data
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    FetchCapacity,
    SetCityID
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(DestinationPanel);



// WEBPACK FOOTER //
// ./src/components/itinerary/editTrip/components/destination-panel.js